import { BadgeVariant, enumRecordToCheckboxOptions } from '@umss/shared/utils';

export enum LinkRequestStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  CANCELLED = 'Cancelled'
}

export const LINK_REQUEST_STATUS_RECORD: Record<LinkRequestStatus, string> = {
  [LinkRequestStatus.PENDING]: 'Pending',
  [LinkRequestStatus.APPROVED]: 'Approved',
  [LinkRequestStatus.REJECTED]: 'Rejected',
  [LinkRequestStatus.CANCELLED]: 'Cancelled'
};

export const LINK_REQUEST_BADGE_VARIANT_RECORD: Record<
  LinkRequestStatus,
  BadgeVariant
> = {
  [LinkRequestStatus.PENDING]: 'warning',
  [LinkRequestStatus.APPROVED]: 'success',
  [LinkRequestStatus.REJECTED]: 'error',
  [LinkRequestStatus.CANCELLED]: 'secondary'
};

export const LINK_REQUEST_STATUS_OPTIONS = enumRecordToCheckboxOptions(
  LINK_REQUEST_STATUS_RECORD
);
